import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import LoginContent from "./LoginContent";

function LoginMain() {
  return (
    <div className="p-3">
      {/*Add title and metadata */}
      <title>Login Screen</title>
      <meta name="robots" content="noindex"></meta>

      {/*navbar*/}
      <NavBar />
      {/* Login body */}
      <LoginContent />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default LoginMain;
